import { callZpayFunction } from '../../callZpayFunction';

// 주문 추가
export const addOrder = (order_number: string) => {
  callZpayFunction('addOrder')({ order_number });
};
